import React from 'react';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import { tooltipMessages } from '../../messages/messages.js';

class InfoTooltip extends React.Component {

    render() {
        let message = tooltipMessages[this.props.message];
        const classes = this.props.class ? this.props.class : 'float-right';
        const placement = this.props.placement ? this.props.placement : 'right';
        return(
            <span>
                <Tooltip arrow title={ message } placement={placement}>
                    <InfoOutlinedIcon color='primary' style={{ fontSize: 20 }} className={classes}/>
                </Tooltip>          
            </span>
        );
    } 
}

export default InfoTooltip;